module.exports = __webpack_public_path__ + "img/sl.b25c022c.svg";